import { render, staticRenderFns } from "./CarouselBanner.vue?vue&type=template&id=aa9ffc74&"
import script from "./CarouselBanner.vue?vue&type=script&lang=js&"
export * from "./CarouselBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports